import React from 'react';
import {
  Container,
  Item,
  Spinner,
  CheckIcon,
  FailIcon,
  Name,
  Duration,
} from './ToolCallStatus.styled';

function formatDuration(ms) {
  if (ms == null || ms < 0) return '';
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}

/**
 * ToolCallStatus - List of tool calls with spinner (in-progress), checkmark (completed), X (failed).
 * Shows duration for completed calls.
 */
const ToolCallStatus = ({ toolCalls = [] }) => {
  if (!toolCalls.length) return null;

  return (
    <Container>
      {toolCalls.map((tc) => {
        const status = tc.status ?? 'started';
        const duration =
          tc.startedAt && tc.completedAt
            ? new Date(tc.completedAt).getTime() - new Date(tc.startedAt).getTime()
            : null;

        return (
          <Item key={tc.id ?? tc.name}>
            {status === 'started' && <Spinner aria-hidden />}
            {status === 'completed' && <CheckIcon aria-hidden>✓</CheckIcon>}
            {status === 'failed' && <FailIcon aria-hidden>✗</FailIcon>}
            <Name>{tc.name ?? 'Tool'}</Name>
            {duration != null && <Duration>{formatDuration(duration)}</Duration>}
          </Item>
        );
      })}
    </Container>
  );
};

export default ToolCallStatus;
